export function FastIcon({ className }: { className?: string }) {
    return (
      <svg 
        className={className} 
        width="48" 
        height="56" 
        viewBox="0 0 48 56" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          fillRule="evenodd" 
          clipRule="evenodd" 
          d="M30.9734 0.252947C31.3638 0.470264 31.6702 0.812076 31.8438 1.22386C32.0173 1.63564 32.0479 2.09366 31.9307 2.52487L26.6187 21.9989H46.0001C46.3899 21.9989 46.7711 22.1128 47.097 22.3266C47.4229 22.5404 47.6793 22.8447 47.8345 23.2022C47.9897 23.5597 48.0371 23.9548 47.9709 24.3389C47.9046 24.723 47.7275 25.0793 47.4615 25.3641L19.4613 55.3631C19.1563 55.6905 18.7504 55.9063 18.3083 55.9757C17.8663 56.0452 17.4137 55.9645 17.0229 55.7464C16.6322 55.5283 16.3259 55.1855 16.153 54.7728C15.9801 54.36 15.9506 53.9013 16.0693 53.4698L21.3813 33.9985H1.99988C1.61012 33.9984 1.22885 33.8845 0.902958 33.6708C0.577061 33.457 0.320736 33.1526 0.165492 32.7951C0.0102485 32.4376 -0.0371489 32.0425 0.0291271 31.6585C0.0954032 31.2744 0.272464 30.9181 0.538544 30.6333L28.5387 0.634267C28.8437 0.308001 29.2491 0.093199 29.6903 0.0240918C30.1316 -0.0450155 30.5832 0.0355491 30.9734 0.252947Z" 
          fill="url(#paint0_linear_fast)" 
        />
        <defs>
          <linearGradient 
            id="paint0_linear_fast" 
            x1="26" 
            y1="-9.5" 
            x2="53.8685" 
            y2="7.75252" 
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F3F9A7"/>
            <stop offset="1" stopColor="#CAC531"/>
          </linearGradient>
        </defs>
      </svg>
    )
  }